import { render, staticRenderFns } from "./UserPermissionsForm.vue?vue&type=template&id=601ef874&"
import script from "./UserPermissionsForm.vue?vue&type=script&lang=js&"
export * from "./UserPermissionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports